var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"debugger"},[_c('debugger-config',{staticStyle:{"position":"sticky","top":"0"},attrs:{"model":_vm.model}}),_c('debugger-output')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }